export enum ContactType {
    INSURANCE_OPTIONS = 'InsuranceOptions',
    CHRONIC_DISEASES = 'ProgramInformation',
    QUIT_SMOKING_PROGRAM = 'QuitSmokingProgram'
  }
  